import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

/// A altura máxima vira variável CSS que cada coluna lê; sem medida ainda, a coluna usa o padrão dela.
/// A linha tem altura fixa para a barra de rolagem ficar no pé da tela, alta ou baixa a maior coluna.
/// A barra come a área de conteúdo, por isso entra na conta junto com o pb.
export const columnsRowSx = (columnsMaxHeight: number | null, scrollbarHeight: number): SxProps<Theme> => ({
    display: 'flex',
    gap: 1.75,
    overflowX: 'auto',
    pb: 2,
    alignItems: 'flex-start',
    ...(columnsMaxHeight !== null && {
        '--crm-column-max-height': `${columnsMaxHeight}px`,
        height: `${columnsMaxHeight + scrollbarHeight + 16}px`,
    }),
});

export const addColumnButtonSx = (cc: CrmColors, darkMode: boolean): SxProps<Theme> => ({
    // Cede largura antes de empurrar a linha para a rolagem: sozinho, transbordava.
    flex: '0 1 250px',
    minWidth: 160,
    whiteSpace: 'nowrap',
    borderRadius: '12px',
    border: `1px dashed ${cc.borderStrong}`,
    color: cc.textMuted,
    textTransform: 'none',
    fontWeight: 600,
    py: 1.25,
    justifyContent: 'center',
    '&:hover': {
        color: cc.textPrimary,
        bgcolor: darkMode ? 'rgba(255,255,255,.04)' : 'rgba(0,0,0,.04)',
        borderColor: cc.borderHover,
    },
});
